import React from 'react';
import Tooltip from '../ui-components/Tooltip.jsx';
import { isDisplayableRange } from '../utils/helpers.js';

const SessionCard = ({
  session,
  style,
  onClick,
  primaryColor = '#1e62d8',
  sessionIndex = 0,
  visibleFields = [],
  isHighlighted = false,
}) => {
  const isClickable = typeof onClick === 'function';

  const handleClick = () => {
    if (isClickable) {
      onClick(session.id);
    }
  };

  const calculateZIndex = sessionIndex => {
    return Math.min(sessionIndex + 1, 999);
  };

  const cardStyle = {
    ...style,
    zIndex: calculateZIndex(sessionIndex),
    // Ensure proper box-sizing for fractional widths
    boxSizing: 'border-box',
    ...(primaryColor && {
      '--primary-color': primaryColor,
    }),
  };

  const tooltipContent = (
    <div className="tooltip-session">
      {session?.title && (
        <div className="tooltip-session__title">
          {session.title}
          {session.subsessions?.length > 0 && (
            <span className="tooltip-session__subsessions-badge">{session.subsessions.length}</span>
          )}
        </div>
      )}
      <div className="tooltip-session__meta">
        {isDisplayableRange(session.range) ? (
          <span className="tooltip-session__time">{session.range}</span>
        ) : null}
        {session?.location && <span className="tooltip-session__location">{session.location}</span>}
      </div>
    </div>
  );

  const cardClassName =
    `session-card session-card--default ${isClickable ? 'session-card--clickable' : ''} ${
      isHighlighted ? 'session-card--highlighted' : ''
    }`.trim();

  return (
    <Tooltip content={tooltipContent} placement="top" className="session-card__tooltip-wrap" style={cardStyle}>
      <div className={cardClassName} onClick={handleClick} data-session-id={session?.id}>
        {visibleFields.includes('track') && session?.track && (
          <div className="session-card__track-badge" style={{ backgroundColor: session.track_color || primaryColor }}>
            {session.track}
          </div>
        )}
        <div className="session-card__details">
          {session?.title && (
            <div className="session-card__title">
              {session.title}
              {session.subsessions?.length > 0 && (
                <span className="session-card__subsessions-badge">{session.subsessions.length}</span>
              )}
            </div>
          )}
          {(visibleFields.includes('starts_at') || visibleFields.includes('ends_at')) &&
            isDisplayableRange(session.range) && (
              <div className="session-card__time">{session.range}</div>
            )}
          {visibleFields.includes('location') && session?.location && (
            <div className="session-card__location">{session.location}</div>
          )}
        </div>
      </div>
    </Tooltip>
  );
};

export default SessionCard;
